var map = {
	"./other.svg": "cf1a",
	"./sdg1.svg": "e4e4",
	"./sdg10.svg": "8eda",
	"./sdg11.svg": "56db",
	"./sdg12.svg": "e859",
	"./sdg13.svg": "92c8",
	"./sdg14.svg": "cff1",
	"./sdg15.svg": "4fe7",
	"./sdg16.svg": "1ce4",
	"./sdg17.svg": "b611",
	"./sdg2.svg": "64fe",
	"./sdg3.svg": "e9b7",
	"./sdg4.svg": "8897",
	"./sdg5.svg": "e378",
	"./sdg6.svg": "c30b",
	"./sdg7.svg": "6b0d",
	"./sdg8.svg": "31aa",
	"./sdg9.svg": "5a2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebae";